/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {formatDate} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {FabMessageService} from '@fabric/components/message';
import {ColDef} from 'ag-grid-community';
import {DISMISS_MSG, VEHICLE_COLDEF, VEHICLE_PROPULSION_COLDEF_NO_FILTER} from '../../../common/constants';
import {StateService} from '../../../core/state/state.service';
import {GlobalScenario} from '../../../models/global-scenario-dto.model';
import {ExcelExportService} from '../../../services/excel-export.service';
import {GlobalScenarioService} from '../../../services/global-scenario-service';

@Component({
    selector: 'app-global-scenario-associations',
    templateUrl: './global-scenario-associations.component.html',
    styleUrl: './global-scenario-associations.component.scss',
    standalone: false
})
export class GlobalScenarioAssociationsComponent implements OnInit {
  showSpinner: boolean;
  globalScenario: GlobalScenario;
  columnHeaders: ColDef[] = VEHICLE_PROPULSION_COLDEF_NO_FILTER


  constructor(protected readonly stateService: StateService,
              protected readonly globalScenarioService: GlobalScenarioService,
              protected readonly excelService: ExcelExportService,
              public snackBar: FabMessageService) {
  }

  ngOnInit(): void {
    this.showSpinner = false;
    this.globalScenario = null;
  }

  /**
   * Event handler for clicking a global scenario
   * @param event the event with the selected scenario
   */
  onSelect(event: any) {
    this.globalScenario = event.globalScenario;
  }

  /**
   * Gets the associations report for a selected global scenario
   */
  getGlobalScenarioAssociations(): void {
    this.showSpinner = true;
    const currDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    const fileName = this.globalScenario.globalScenarioName + '_Associations_' + currDate;
    this.globalScenarioService.getGlobalScenarioAssociations(this.globalScenario.id).subscribe(
      (file: any) => {
        this.excelService.exportToExcelFromServer(file, fileName);
      },
      () => {
        this.showSpinner = false;
        this.snackBar.displayError('Error with exporting data.', DISMISS_MSG);
      }, () => {
        this.showSpinner = false;
        this.snackBar.displaySuccess('Successfully retrieved associations.', DISMISS_MSG);
      });
  }

  protected readonly DEFAULT_VEHICLE_COL_HEADERS_AGGRID = VEHICLE_COLDEF;
}
